const TOKEN_KEY = 'sc_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export async function api(path, { method = 'GET', body } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`/api${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401) clearToken();
    throw new Error(data.error || 'Error de conexión');
  }
  return data;
}

export const fmtCRC = (n) => `₡${Number(n || 0).toLocaleString('es-CR')}`;

// Las suscripciones importadas pueden no tener fecha de corte todavía, así que
// todo el formateo de fechas tolera el vacío en lugar de mostrar "Invalid Date".
export const fmtDate = (d) =>
  (d ? new Date(d).toLocaleDateString('es-CR', { day: 'numeric', month: 'short', year: 'numeric' }) : 'Sin fecha');

// Días que faltan (o pasaron) para una fecha. Negativo = ya venció. null = sin fecha.
export const daysUntil = (d) => {
  if (!d) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(d);
  target.setHours(0, 0, 0, 0);
  return Math.round((target - today) / 86400000);
};

// Texto de cuenta regresiva legible
export const dueLabel = (d) => {
  const n = daysUntil(d);
  if (n == null) return 'sin fecha definida';
  if (n < 0) return `vencido hace ${-n} día${-n !== 1 ? 's' : ''}`;
  if (n === 0) return 'vence hoy';
  if (n === 1) return 'vence mañana';
  return `faltan ${n} días`;
};

// Antigüedad como cliente
export const sinceLabel = (d) => {
  const n = -daysUntil(d);
  if (n < 30) return `${n} día${n !== 1 ? 's' : ''}`;
  const months = Math.floor(n / 30);
  if (months < 12) return `${months} mes${months !== 1 ? 'es' : ''}`;
  const years = Math.floor(months / 12);
  return `${years} año${years !== 1 ? 's' : ''}`;
};

// Variables que acepta una plantilla, iguales a las del servidor (plan Pro)
const TEMPLATE_KEYS = ['cliente', 'servicio', 'fecha', 'monto', 'correo', 'contrasena', 'perfil', 'pin', 'negocio'];

// Rellena la plantilla de WhatsApp igual que lo hace el envío automático del Pro
export const renderTemplate = (template, values = {}) =>
  TEMPLATE_KEYS.reduce(
    (text, key) => text.replaceAll(`{${key}}`, values[key] || ''),
    String(template || 'Hola {cliente}, te recuerdo el pago de {servicio}.')
  ).trim();

// Antepone el código de país del vendedor a los números locales de 8 dígitos
export const waPhone = (phone, countryCode = '506') => {
  const clean = String(phone || '').replace(/\D/g, '');
  const code = String(countryCode || '506').replace(/\D/g, '') || '506';
  return clean.length === 8 ? `${code}${clean}` : clean;
};

// Arma el enlace wa.me con el mensaje ya listo (envío asistido del plan Básico)
export const waLink = (phone, template, values = {}, countryCode = '506') =>
  `https://wa.me/${waPhone(phone, countryCode)}?text=${encodeURIComponent(renderTemplate(template, values))}`;
